import { render, staticRenderFns } from "./PlanTemplates.vue?vue&type=template&id=5cf1edf0"
import script from "./PlanTemplates.ts?vue&type=script&lang=ts&external"
export * from "./PlanTemplates.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports